import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Ordergeschiedenis',
  labels: {
    dummy_order: 'Testorder',
    orders_number: 'Aantal orders ({{count}})',
    revenue: 'Omzet: {{amount}}',
    tips: 'Fooi: {{amount}}',
    cash_sales: ' ({{amount}} contant)',
    refunds: 'Terugbetalingen: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Afhalen',
    [OrderMethod.Delivery]: 'Bezorging',
    [OrderMethod.OnSite]: 'Bestelling aan tafel',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'In behandeling',
    [OrderFulfillmentStatus.Reviewed]: 'In behandeling',
    [OrderFulfillmentStatus.Accepted]: 'In behandeling',
    [OrderFulfillmentStatus.Preparing]: 'In behandeling',
    [OrderFulfillmentStatus.Ready]: 'In behandeling',
    [OrderFulfillmentStatus.OnDelivery]: 'In behandeling',
    [OrderFulfillmentStatus.Picked]: 'Voltooid',
    [OrderFulfillmentStatus.Rejected]: 'Geweigerd',
  },
  payment_methods: {
    invoice: 'Factuur',
    cash: 'Contant',
    online: 'Online methode',
  },
  filters: {
    all: 'Alle',
  },
  fields: {
    order_placed: 'Bestelling geplaatst',
    order_number: '#',
    customer: 'Klant',
    payment_method: 'Betaalmethode',
    method: 'Type',
    status: 'Status',
    total: 'Totaal',
  },
  buttons: {
    print: 'Afdrukken',
    create_test_order: 'Testbestelling aanmaken',
  },
  toasts: {
    failed_to_fetch_orders: 'Gegevens laden mislukt. Klik op het vernieuw-icoon of probeer het over 1 minuut opnieuw.',
    something_went_wrong: 'Er is iets misgegaan, probeer het opnieuw.',
    failed_to_create_test_order: 'Testbestelling aanmaken mislukt',
    test_order_created: 'Testbestelling aangemaakt',
  },
};
